import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '@interacta-shared/ui-icons';
import { IWorkspace } from '@interacta/util-community';
import { CurrentLanguagePipe } from '@modules/shared-v2/pipes/current-language.pipe';

@Component({
    selector: 'interacta-sidebar-workspace',
    templateUrl: './sidebar-workspace.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, IconComponent, MatTooltip, CurrentLanguagePipe],
})
export class SidebarWorkspaceComponent {
    readonly workspace =
        input.required<Pick<IWorkspace, 'id' | 'name' | 'communities'>>();
    readonly isCollapsed = input(true);
    readonly expanded = input(true);
    readonly selected = input(false);
}
